;(function ( $ ) {

    /**
     *  headerMessage
     *  fit message to header height
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'headerMessage';
    var defaults = {
        duration: 7000
    };

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            $(this.element).hide();
            this.setHeaderHeight();
            $(this.element).show().addClass('slideInDown animated');
            this.registerEvents();
        },

        registerEvents: function() {
            var _this = this;
            $(window).smartresize(function() {
                _this.setHeaderHeight();
            });
            $(this.element).on('click', function(e) {
                $(this).removeClass('slideInDown').addClass('slideOutUp fast');
            });
            window.setTimeout(function() {
                $(_this.element).removeClass('slideInDown').addClass('slideOutUp');
            }, _this.settings.duration);
        },

        setHeaderHeight: function() {
            var h = 0;
            var marginTop = parseInt($('body').css('margin-top'));
            h += marginTop;
            $('body').find('header').each(function() {
                h += $(this).height();
            });
            $(this.element).height(h);
            var paddingTop = (h / 2) - 20;
            $(this.element).find('.wrapper').css('padding-top', paddingTop + 'px');
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
